import { Module as ModuleConfig } from '../../types';
import { PlayerHistory } from './history';

export type AllowedScores = | 0 | 1 | 2 | 3;

function calculateScore(correct: number, totalClaims: number): AllowedScores {
  const score = (correct / totalClaims) * 100;
  if (score >= 100) {
    return 3;
  }
  if (score >= 80) {
    return 2;
  }
  if (score >= 60) {
    return 1;
  }
  return 0;
}

function isLocked(module: ModuleConfig, playerHistory: PlayerHistory): boolean {
  const { Requirements } = module;

  if (!Requirements) {
    return false;
  }

  const starsAwarded = playerHistory.records[Requirements]?.starsAwarded;
  return starsAwarded == null || starsAwarded < 2;
}

export const Module = {
  isLocked,
  calculateScore,
};
